module.exports = __webpack_public_path__ + "img/img1.28547576.jpg";